import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _SidebarMoreSectionLinks, _SidebarMoreSectionLinks_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import willDestroy from "@ember/render-modifiers/modifiers/will-destroy";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { bind } from "discourse-common/utils/decorators";
import MoreSectionLink from "./more-section-link";
import SectionLinkButton from "./section-link-button";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let SidebarMoreSectionLinks = (_class = (_SidebarMoreSectionLinks_brand = /*#__PURE__*/new WeakSet(), (_SidebarMoreSectionLinks = class SidebarMoreSectionLinks extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _SidebarMoreSectionLinks_brand);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "activeSectionLink", _descriptor2, this);
    _initializerDefineProperty(this, "open", _descriptor3, this);
    _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _setActiveSectionLink).call(this);
    this.router.on("routeDidChange", this, _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _setActiveSectionLink));
  }
  willDestroy() {
    super.willDestroy(...arguments);
    _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _removeClickEventListener).call(this);
    this.router.off("routeDidChange", this, _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _setActiveSectionLink));
  }
  get sectionLinks() {
    if (this.activeSectionLink) {
      return _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _filterActiveSectionLink).call(this, this.args.sectionLinks);
    } else {
      return this.args.sectionLinks;
    }
  }
  get secondarySectionLinks() {
    if (this.activeSectionLink) {
      return _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _filterActiveSectionLink).call(this, this.args.secondarySectionLinks);
    } else {
      return this.args.secondarySectionLinks;
    }
  }
  closeDetails(event1) {
    if (event1.target.closest(".sidebar-more-section-links-details-summary")) {
      return;
    }
    if (this.open) {
      const isLinkClick1 = event1.target.className.includes("sidebar-section-link") || event1.target.className.includes("--link-button");
      if (isLinkClick1 || _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _isOutsideDetailsClick).call(this, event1)) {
        this.open = false;
      }
    }
  }
  registerClickListener() {
    _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _addClickEventListener).call(this);
  }
  unregisterClickListener() {
    _assertClassBrand(_SidebarMoreSectionLinks_brand, this, _removeClickEventListener).call(this);
  }
  toggleSectionLinks(event1) {
    event1.stopPropagation();
    this.open = !this.open;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    {{#if this.activeSectionLink}}
      <MoreSectionLink @sectionLink={{this.activeSectionLink}} />
    {{/if}}

    <li class="sidebar-section-link-wrapper">
      <button
        {{on "click" this.toggleSectionLinks}}
        aria-expanded={{if this.open "true" "false"}}
        class="sidebar-section-link sidebar-row sidebar-more-section-links-details-summary --link-button"
      >
        <span class="sidebar-section-link-prefix icon">
          {{icon "ellipsis-v"}}
        </span>
        <span class="sidebar-section-link-content-text">
          {{i18n "sidebar.more"}}
        </span>
      </button>
    </li>

    {{#if this.open}}
      <div class="sidebar-more-section-links-details">
        <div
          {{didInsert this.registerClickListener}}
          {{willDestroy this.unregisterClickListener}}
          class="sidebar-more-section-links-details-content-wrapper"
        >

          <div class="sidebar-more-section-links-details-content">
            <ul class="sidebar-more-section-links-details-content-main">
              {{#each this.sectionLinks as |sectionLink|}}
                <MoreSectionLink @sectionLink={{sectionLink}} />
              {{/each}}
            </ul>

            {{#if @moreButtonAction}}
              <div class="sidebar-more-section-links-details-content-footer">
                <SectionLinkButton
                  @action={{@moreButtonAction}}
                  @icon={{@moreButtonIcon}}
                  @text={{@moreButtonText}}
                  @name="customize"
                />
              </div>
            {{/if}}
          </div>
        </div>
      </div>
    {{/if}}
  
*/
{
  "id": "zmg5lDcs",
  "block": "[[[1,\"\\n\"],[41,[30,0,[\"activeSectionLink\"]],[[[1,\"      \"],[8,[32,0],null,[[\"@sectionLink\"],[[30,0,[\"activeSectionLink\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,\"li\"],[14,0,\"sidebar-section-link-wrapper\"],[12],[1,\"\\n      \"],[11,\"button\"],[16,\"aria-expanded\",[52,[30,0,[\"open\"]],\"true\",\"false\"]],[24,0,\"sidebar-section-link sidebar-row sidebar-more-section-links-details-summary --link-button\"],[4,[32,1],[\"click\",[30,0,[\"toggleSectionLinks\"]]],null],[12],[1,\"\\n        \"],[10,1],[14,0,\"sidebar-section-link-prefix icon\"],[12],[1,\"\\n          \"],[1,[28,[32,2],[\"ellipsis-v\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"sidebar-section-link-content-text\"],[12],[1,\"\\n          \"],[1,[28,[32,3],[\"sidebar.more\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"open\"]],[[[1,\"      \"],[10,0],[14,0,\"sidebar-more-section-links-details\"],[12],[1,\"\\n        \"],[11,0],[24,0,\"sidebar-more-section-links-details-content-wrapper\"],[4,[32,4],[[30,0,[\"registerClickListener\"]]],null],[4,[32,5],[[30,0,[\"unregisterClickListener\"]]],null],[12],[1,\"\\n\\n          \"],[10,0],[14,0,\"sidebar-more-section-links-details-content\"],[12],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"sidebar-more-section-links-details-content-main\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"sectionLinks\"]]],null]],null],null,[[[1,\"                \"],[8,[32,0],null,[[\"@sectionLink\"],[[30,1]]],null],[1,\"\\n\"]],[1]],null],[1,\"            \"],[13],[1,\"\\n\\n\"],[41,[30,2],[[[1,\"              \"],[10,0],[14,0,\"sidebar-more-section-links-details-content-footer\"],[12],[1,\"\\n                \"],[8,[32,6],null,[[\"@action\",\"@icon\",\"@text\",\"@name\"],[[30,2],[30,3],[30,4],\"customize\"]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"sectionLink\",\"@moreButtonAction\",\"@moreButtonIcon\",\"@moreButtonText\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/more-section-links.js",
  "scope": () => [MoreSectionLink, on, icon, i18n, didInsert, willDestroy, SectionLinkButton],
  "isStrictMode": true
}), _SidebarMoreSectionLinks), _SidebarMoreSectionLinks)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activeSectionLink", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "open", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "closeDetails", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "closeDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerClickListener", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerClickListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterClickListener", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterClickListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSectionLinks", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSectionLinks"), _class.prototype)), _class);
function _filterActiveSectionLink(sectionLinks1) {
  return sectionLinks1.filter(sectionLink1 => {
    return sectionLink1.name !== this.activeSectionLink.name;
  });
}
function _removeClickEventListener() {
  document.removeEventListener("click", this.closeDetails);
}
function _addClickEventListener() {
  document.addEventListener("click", this.closeDetails);
}
function _isOutsideDetailsClick(event1) {
  return !event1.composedPath().some(element1 => {
    return element1.className === "sidebar-more-section-links-details";
  });
}
function _setActiveSectionLink() {
  this.activeSectionLink = this.args.sectionLinks.find(sectionLink1 => {
    const args1 = [sectionLink1.route];
    if (sectionLink1.model) {
      args1.push(sectionLink1.model);
    } else if (sectionLink1.models) {
      args1.push(...sectionLink1.models);
    }
    if (!isEmpty(sectionLink1.query)) {
      args1.push({
        queryParams: sectionLink1.query
      });
    }
    return this.router.isActive(...args1) && sectionLink1;
  });
}
export { SidebarMoreSectionLinks as default };